export default "__VITE_ASSET__CBe8tI7G__"